<template>
  <div id="CourseInfo">
    <p class="title">{{ course.title }}</p>
    <p class="time">发布人: {{ course.publisherName }}</p>
    <p
      class="info"
      ref="info"
      :style="{'max-height': (infoShowAll ? '' : `${infoMaxHeight}px`)}">
      <span>{{ course.description }}</span>
    </p>
    <VuiButton
      v-if="infoNeedButton"
      class="btn"
      type="text"
      @click.native="infoShowAll = !infoShowAll"
    >{{ infoShowAll ? '收起' : '查看全部' }}</VuiButton>

    <div class="course_info_qrcode" v-if="!isRedirect">
      <p class="course_info_qrcode_title">更多精彩尽在法学院APP</p>
      <img src="/img/qrcode.png" alt="">
      <p class="course_info_qrcode_subtitle">请扫描二维码下载</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CourseInfo',
  props: ['course'],
  data () {
    return {
      isRedirect: !!sessionStorage.getItem('redirectType'),
      infoShowAll: true,
      infoMaxHeight: '',
      infoNeedButton: false,
    }
  },
  computed: {
    ...mapState('course', ['currentVideo']),
  },
  watch: {
    'course.info' () {
      const infoAllowMaxHeight = 80

      // 先充分让其占满空间，然后进行高度测量
      this.infoShowAll = true
      this.infoMaxHeight = ''

      this.$nextTick(() => {
        const { height } = this.$refs.info.getBoundingClientRect()

        if (height > infoAllowMaxHeight) {
          // 如果 当前高度 > 最大允许高度，展示折叠按钮并进行折叠
          this.infoNeedButton = true
          this.infoShowAll = false
          this.infoMaxHeight = infoAllowMaxHeight
        } else {
          // 如果 当前高度 <= 最大允许高度，取消折叠按钮并展开
          this.infoNeedButton = false
          this.infoShowAll = true
        }
      })
    },

  },
}
</script>

<style lang="scss" scoped>
#CourseInfo {
  height: 100%;
  box-sizing: border-box;
  padding: 64px 20px 20px;
  overflow-y: scroll;
  .title {
    @include font(20px, 26px, #000, bold);
  }
  .time {
    @include font(14px, 20px, #868688);
    margin-top: 10px;
  }
  .info {
    @include font(14px, 20px, #4a4a4a);
    margin-top: 16px;
    white-space: pre-wrap;
    overflow: hidden;
  }
  .btn {
    @include font(14px, 20px, #ed6c00);
    margin-top: 10px;
    padding: 0;
  }
  .files-wrap {
    margin-top: 20px;
  }
  .course_info_qrcode {
    text-align: center;
    .course_info_qrcode_title {
      font-size: 16px;
      font-weight: bold;
      margin: 16px 0;
    }
    img {
      height: 110px;
      width: 110px;
    }
    .course_info_qrcode_subtitle {
      margin-top: 8px;
      font-size: 14px;
    }
  }
}
</style>
